import { render, staticRenderFns } from "./salesReturn-add-or-update.vue?vue&type=template&id=3489585d&scoped=true"
import script from "./salesReturn-add-or-update.vue?vue&type=script&lang=js"
export * from "./salesReturn-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./salesReturn-add-or-update.vue?vue&type=style&index=0&id=3489585d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3489585d",
  null
  
)

export default component.exports